import type { InquiryItem } from '@/types/api';
import useCopy from '@/hooks/useCopy';
import CopyIcon from '@/assets/icons/OrderDetails/eva_copy-outline.svg?react';
import { Button } from '@/components/atoms/NewPcButton';

import GenerateAnswer from './GenerateAnswer';
import SubmitButton from './SubmitButton';
import SelectTemplate from './SelectTemplate';

export interface AnswerControllerProps {
  comment: string;
  setComment?: (comment: string) => void; // Optional for AutoResizeTextarea
  inquiry: InquiryItem;
  handleRegister: () => void; // Optional for SubmitButton
  isLoading?: boolean; // Optional for SubmitButton
  recommendationCommentList?: string[]; // Optional for GenerateAIAnswer
}

const AnswerController = ({
  comment,
  setComment,
  inquiry,
  handleRegister,
  isLoading,
}: AnswerControllerProps) => {
  const { copyToClipboard } = useCopy({
    toastMessage: '복사가 완료되었습니다',
  });

  return (
    <>
      <div className="flex items-start justify-between ">
        <div className="flex items-start gap-[8px]">
          <GenerateAnswer inquiry={inquiry} setComment={setComment} />
          <SelectTemplate setComment={setComment} />
          <Button
            onClick={() => copyToClipboard(comment)}
            variant="secondary"
            className=" p-[7px] disabled:text-gr-400"
            disabled={!comment}
          >
            <CopyIcon />
          </Button>
        </div>
        <SubmitButton handleRegister={handleRegister} isLoading={isLoading} comment={comment} />
      </div>
    </>
  );
};

export default AnswerController;
